import React from "react";
import * as R from "ramda";
import { Progress } from "antd";
import { useTranslation } from "react-i18next";

import styled from "styled-components/macro";

const Percentage = styled.div`
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const IvoTestWrapper = styled.div`
  .khorInt_Titulo1,
  .title {
    font-weight: bold;
    border-bottom: 1px solid #00000024;
    padding-bottom: 0.5em;
    margin-bottom: 0.5em;
  }
  ul {
    margin-left: 30px;
    li:not(:last-child) {
      margin-bottom: 0.5em;
    }
  }
`;

const defaultColorScale = ["#F5242E", "#e0b500", "#53C819"];

const PercentageItem = ({
  name,
  value,
  percentage,
  colorScale = defaultColorScale
}) => (
  <Percentage key={name}>
    <span data-test={`ivo-test-${name}`}>{`${name}: ${value}`}</span>
    <Progress
      percent={percentage > 1 ? percentage : 1}
      showInfo={false}
      strokeColor={R.cond([
        [R.gte(40), R.always(colorScale[0])],
        [R.gte(60), R.always(colorScale[1])],
        [R.gte(100), R.always(colorScale[2])]
      ])(percentage)}
    />
  </Percentage>
);

export default function IvoTest({ serviceCallRequest }) {
  const { t } = useTranslation(["opportunity"]);

  try {
    // Human Group sometimes sends the object stringified...
    const result =
      typeof serviceCallRequest === "object"
        ? serviceCallRequest
        : typeof serviceCallRequest === "string"
        ? JSON.parse(serviceCallRequest)
        : null;

    const interpretation = R.either(
      R.path(["interpretacion", "texto"]),
      R.path(["resultados", "interpretacion", "texto"])
    )(result);

    return (
      <IvoTestWrapper>
        {interpretation && (
          <div dangerouslySetInnerHTML={{ __html: interpretation }} />
        )}
        {R.pathOr([], ["resultados", "ValoresOrganizacionales"], result).map(
          ({ Valor, resultado }) => (
            <PercentageItem
              name={Valor}
              value={resultado}
              percentage={resultado * 10}
            />
          )
        )}
        <p className="title">Antivalores Organizacionales</p>
        {R.pathOr(
          [],
          ["resultados", "AntivaloresOrganizacionales"],
          result
        ).map(({ Antivalor, resultado }) => (
          <PercentageItem
            name={Antivalor}
            value={resultado}
            percentage={resultado * 10}
            colorScale={defaultColorScale.reverse()}
          />
        ))}
        <p className="title">Indices</p>
        <ul>
          {R.pathOr([], ["resultados", "indices"], result).map(
            ({ indice, resultado }) => (
              <li key={indice}>
                {indice}: {resultado}
              </li>
            )
          )}
        </ul>
      </IvoTestWrapper>
    );
  } catch (e) {
    console.error(e);
    return (
      <IvoTestWrapper>
        <p>{t("opportunity:process.candidateDetails.testVisualizeError")}</p>
      </IvoTestWrapper>
    );
  }
}
